import Slider from "react-slick";
import "../App.css"; // Make sure this CSS file exists

const ImageSlider = ({images = [], speed = 1000, autoplaySpeed = 3000, slidesToShow = 1, slidesToScroll = 1, height = 400}) => {
    const settings = {
        dots: false,
        infinite: true,
        speed,
        autoplay: true,
        autoplaySpeed,
        slidesToShow,
        slidesToScroll,
        // adaptiveHeight: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {slidesToShow: 1}
            },
            {
                breakpoint: 768,
                settings: {slidesToShow: 1}
            },
            {
                breakpoint: 576,
                settings: {slidesToShow: 1}
            }
        ]
    };

    return (
        <Slider {...settings}>
            {images.map((src, index) => (
                <div key={index}>
                    <img src={src} alt={`slide-${index}`}
                         className="slider-image"
                         style={{
                             padding: "20px",
                             height: `${height}px`,
                             width: "100%",
                             objectFit: "contain"
                         }}
                    />
                </div>
            ))}
        </Slider>
    );
};

export default ImageSlider;